import { configureStore } from '@reduxjs/toolkit';
import entities from './store/entity.slice';

export default configureStore({
    reducer: {
        entities
    }
});